let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("taodl")).then(() => parcelRequire('5AJrF'));